import mixpanel from "mixpanel-browser";

export const MX_INIT = () => {
  mixpanel.init(process.env.VUE_APP_MIXPANEL_TOKEN, {
    debug: process.env.VUE_APP_MIXPANEL_DEBUG === "true",
  });
};

export const identify = (id = {}) => {
  mixpanel.identify(id);
};

export const MX_TRACK = (event, data) => {
  const eventData = { ...data };
  let user = localStorage.getItem("user") || {};
  eventData.distinct_id =
    eventData.distinct_id || localStorage.getItem("email") || user.email;
  eventData.email =
    eventData.email || localStorage.getItem("email") || user.email || "Guest";
  eventData.mobile =
    eventData.mobile ||
    localStorage.getItem("mobile") ||
    user.mobile ||
    "Guest";
  mixpanel.track(event, eventData);
};
